import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableContainer } from '@celebration/design-system/dist/lib/table-container';

export default createComponent({
    react: React,
    elementClass: ClbTableContainer,
    tagName: ClbTableContainer.tagName,
    events: ClbTableContainer.events,
});

export const TableContainerSlots = ClbTableContainer.slots;
